module.exports = "/images/vendor/flag-icon-css/flags/1x1/ad.svg?e15ddeabbfce297178193b7858043ebd";